const RELOAD_KEY = 'chunk_reload_at';
const CHUNK_ERROR = /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module/i;

export async function refreshStaleChunk(error, {
  storage = sessionStorage,
  serviceWorker = navigator.serviceWorker,
  cacheStorage = globalThis.caches,
  online = navigator.onLine,
  now = Date.now(),
} = {}) {
  if (!CHUNK_ERROR.test(error?.message || '') || online === false) return false;

  const last = Number(storage.getItem(RELOAD_KEY) || 0);
  if (now - last <= 30_000) return false;
  storage.setItem(RELOAD_KEY, String(now));

  try {
    // A navegação do Workbox pode continuar servindo um index.html da versão antiga.
    const names = await cacheStorage?.keys();
    await Promise.all((names || [])
      .filter(name => name.startsWith('workbox-precache'))
      .map(name => cacheStorage.delete(name)));
  } catch {
    // Reload still helps when Cache Storage is unavailable.
  }

  try {
    const registration = await serviceWorker?.getRegistration();
    await registration?.update();
  } catch {
    // A fresh navigation can recover even if the worker update fails.
  }

  return true;
}
